import React from 'react';

import LinkButton from '@/components/atoms/linkButton';
import RichTextFieldSB from '@/components/atoms/richTextField/RichTextFieldSB';
import { OfferCountdownStatus } from '@/components/countdown';

import { BannerContentProps } from './types';

export const BannerContent = ({
  renderImage,
  bannerText,
  bannerCta,
  endDate,
}: BannerContentProps) => {
  return (
    <div className='max-section-width flex h-full min-h-[52px] w-full flex-col items-center justify-between gap-x-3 gap-y-5 md:flex-row md:gap-y-0'>
      <div className='flex items-center gap-3 text-center md:text-left'>
        {renderImage({ classNames: { image: 'w-4 h-4' } })}
        <div className='text-body-m font-semibold'>
          <RichTextFieldSB block={bannerText} />
        </div>
      </div>
      {!!endDate && <OfferCountdownStatus size='m' expiry={endDate} />}
      <div data-tracker-component='action'>
        <LinkButton
          size='s'
          classNames={{ root: 'md:w-32 w-full' }}
          data-tracker-component='top-banner-cta'
          variant={bannerCta?.variant || 'filled'}
          color={bannerCta?.color || 'secondary'}
          href={bannerCta?.url}
        >
          {bannerCta?.text}
        </LinkButton>
      </div>
    </div>
  );
};
